import React from 'react';
import './Skill.css';

const skillCategories = [
    {
        title: "Frontend Development",
        skills: ["React", "Next.js", "TypeScript", "JavaScript", "HTML5", "CSS3", "Tailwind CSS"]
    },
    {
        title: "Backend & Database",
        skills: ["Python", "FastAPI", "Node.js", "Express.js", "PostgreSQL", "MongoDB", "REST APIs"]
    },
    {
        title: "Cloud & DevOps",
        skills: ["AWS (S3, EC2, Lambda)", "System Deployment", "Git & GitHub", "Docker", "CI/CD"]
    },
    {
        title: "AI & Specialized",
        skills: ["LLM Integration", "AI Automation", "Full-Stack Architecture", "Admin Dashboards"]
    }
];

const Skill = () => {
    return (
        <section id="Skills" className="skill mt-5 pt-4 pb-5">
            <div className="container">
                <div className="section-header mb-5 text-center">
                    <h2 className="title">Technical Expertise</h2>
                    <p className="subtitle text-light mt-3 mx-auto" style={{ maxWidth: "750px", lineHeight: "1.6" }}>
                        I specialize in building production-grade web applications and AI-powered systems, taking ownership of full-stack development from architecture to deployment. I enjoy turning complex requirements into clean, reliable solutions.
                    </p>
                </div>
                
                <div className="skills-grid">
                    {skillCategories.map((category, index) => (
                        <div key={index} className="skill-card">
                            <h3 className="skill-card-title">{category.title}</h3>
                            <div className="skill-tags">
                                {category.skills.map((skill, i) => (
                                    <span key={i} className="skill-tag">{skill}</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skill;